"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertCondition = void 0;
function assertCondition(condition) {
    if (!condition) {
        throw new Error("Assertion failed");
    }
}
exports.assertCondition = assertCondition;
